module.exports = __webpack_public_path__ + "prod/1.42.2/img/solution_four.c471a2c1.png";